import { lazy } from "react";

export { MY_DOCUMENTS_FOR_SIGNING_PATH } from "./my-documents-for-signing-path";
export const MyDocumentsForSigningPage = lazy(
  () => import("./my-documents-for-signing-page"),
);
